export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=16870166&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=16870166&
// module id = 130
// module chunks = 1